import BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';

/**
 * Gets the left nav max width for the current browser window width
 */
export function getLeftNavMaxWidth(browserWidthBucket: BrowserWidthBucket): number {
    switch (browserWidthBucket) {
        case BrowserWidthBucket.From418_Below:
        case BrowserWidthBucket.From419_To499:
        case BrowserWidthBucket.From500_To541:
        case BrowserWidthBucket.From542_To554:
        case BrowserWidthBucket.From555_To579:
        case BrowserWidthBucket.From580_To685:
        case BrowserWidthBucket.From686_To691:
        case BrowserWidthBucket.From692_To768:
        case BrowserWidthBucket.From769_To865:
        case BrowserWidthBucket.From866_To899:
        case BrowserWidthBucket.From900_To918:
        case BrowserWidthBucket.From919_To999:
        case BrowserWidthBucket.From1000_To1079:
            return 49;
        case BrowserWidthBucket.From1080_To1199:
            return 236;
        case BrowserWidthBucket.From1200_To1238:
        case BrowserWidthBucket.From1239_To1300:
        case BrowserWidthBucket.From1301_To1365:
        case BrowserWidthBucket.From1366_To1399:
            return 254;
        case BrowserWidthBucket.From1400_To1599:
            return 300;
        case BrowserWidthBucket.From1600_Above:
        default:
            return 320;
    }
}
